// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ProductionOperators_GetResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for GET /so/production_operators/get/{id}
 *
 * Returns a single production operator record. Wire shape:
 * `dados: ProductionOperators_OperatorRow`.
 *
 * @see ProductionOperators_OperatorRow
 * @see So_production_operators_model::getById()
 */
import type { ProductionOperators_OperatorRow } from './ProductionOperators_OperatorRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ProductionOperators_GetResponseDados = ProductionOperators_OperatorRow;

export type ProductionOperators_GetResponse = ApiResponse<ProductionOperators_GetResponseDados>;

registerResponseContract('ProductionOperators_GetResponse', {
  production_operator_id: { type: 'number',  required: true },
  franchise_id:           { type: 'number',  required: true },
  display_name:           { type: 'string',  required: true },
  badge_qrcode:           { type: 'string',  required: true },
  badge_number:           { type: 'string',  required: false },
  cognito_user_id:        { type: 'string',  required: false },
  is_active:              { type: 'number',  required: true },
  avatar_url:             { type: 'string',  required: false },
  color_hex:              { type: 'string',  required: false },
  created_at:             { type: 'string',  required: true },
  updated_at:             { type: 'string',  required: false },
})
